module.exports = __webpack_public_path__ + "static/media/Fresh_Pack_Rose_30.a951f7e4.png";